import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}categories-product-detail`;

const token = localStorage.getItem('token');

export const getProductsCategoriesDetail = () => {
    const token = localStorage.getItem('token');

    return axios.get(API_URL_WEB, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getProductCategoriesDetailById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const createProductCategoriesDetail = (productDetail) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL_WEB, productDetail, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateProductCategoriesDetail = (id, productDetail) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, productDetail, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const deleteProductCategoriesDetail = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    })
}